import React from 'react';

import Meta from '../components/Meta';
import HeaderSection from "../components/header/HeaderSection";

const Page = () => {
  return (
    <>
      <Meta title="Privacy - The Engineering Book Club"/>
      <HeaderSection title="Privacy" subtitle="Last updated: February 2026"/>

      <section className="relative py-1 md:py-24">
        <div className="container">
          <div className="mx-auto max-w-[48.125rem]">
            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">Introduction</h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              This is going to be the simplest privacy policy you have ever read. We want to be
              transparent about what data we collect, how we use it, and what tools we rely on
              to run this project.
            </p>

            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">Tools that we use</h2>
            <ul className="dark:text-jacarta-60 mb-5 list-disc pl-5 leading-normal">
              <li className="mb-2"><strong>Website hosting:</strong> Vercel (www.engineeringbookclub.com)</li>
              <li className="mb-2"><strong>Community platform:</strong> Discord</li>
              <li className="mb-2"><strong>Newsletter and email:</strong> Sendy hosted on a VPS in DigitalOcean with MySQL.
                Emails are sent via Amazon SES.</li>
              <li className="mb-2"><strong>Payments:</strong> Stripe for Pro membership subscriptions. We do not store
                any payment or card information.</li>
              <li className="mb-2"><strong>Analytics:</strong> Vercel Analytics</li>
              <li className="mb-2"><strong>Podcast hosting:</strong> Apple Podcasts and YouTube</li>
            </ul>

            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">Data that we collect</h2>
            <p className="dark:text-jacarta-60 mb-3 leading-normal">
              We collect the minimum amount of data needed to run the community:
            </p>
            <ul className="dark:text-jacarta-60 mb-5 list-disc pl-5 leading-normal">
              <li className="mb-2"><strong>Email address:</strong> When you subscribe to our newsletter. Used only
                to send you the weekly newsletter. You can unsubscribe at any time.</li>
              <li className="mb-2"><strong>Discord profile:</strong> When you join our Discord community. We do not
                control this data — it is managed by Discord according to their own privacy policy.</li>
              <li className="mb-2"><strong>Payment information:</strong> When you subscribe to a Pro membership,
                Stripe handles all payment processing. We only receive confirmation of your subscription
                status — we never see or store your card details.</li>
              <li className="mb-2"><strong>Website analytics:</strong> We collect anonymous, aggregated usage data
                (page views, country) through Vercel Analytics. No cookies are used for tracking,
                and no personally identifiable information is collected.</li>
            </ul>

            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">What we do not do</h2>
            <ul className="dark:text-jacarta-60 mb-5 list-disc pl-5 leading-normal">
              <li className="mb-2">We do not sell your data to third parties.</li>
              <li className="mb-2">We do not show ads.</li>
              <li className="mb-2">We do not use tracking cookies.</li>
              <li className="mb-2">We do not share your email with anyone outside the Engineering Book Club.</li>
            </ul>

            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">Contact</h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              If you have any questions about your data or this privacy policy, reach out to us
              at hello@engineeringbookclub.com.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Page;
